import React from 'react';
/*eslint import/namespace: ['error', { allowComputed: true }]*/
import * as Icon from '@material-ui/icons/';
import type { Attributes, HTMLAttributes } from 'react';
import type { MaterialIconType } from '../../util/types';
import type { IconProps } from './types';
import IconWrapper from './common/IconWrapper';
import { ICON_MATERIAL, ICON_MATERIAL_PERSIST_COLOR } from '../../util/data-id';

type Ref = HTMLDivElement;
type HTMLProps = Omit<HTMLAttributes<Ref>, 'color'>;
interface Props extends IconProps, HTMLProps {
  /**
   * Sets Material icon by identification name.
   * https://material.io/icons/
   */
  icon: MaterialIconType;
  /**
   * Adds custom style to filter icon.
   */
  isCustomFilterIcon?: boolean;
}

type AttrType = {
  'data-id': string;
  'data-icon-filter'?: string;
};

const MaterialIcon = React.forwardRef<Ref, Props>(({ icon, color, size, persistColor, isCustomFilterIcon = false, ...other }: Props, ref): JSX.Element => {
  let attr: AttrType = {
    'data-id': persistColor ? ICON_MATERIAL_PERSIST_COLOR : ICON_MATERIAL,
  };

  if (isCustomFilterIcon) {
    attr = {
      ...attr,
      'data-icon-filter': 'true',
    };
  }

  const DynamicIcon = React.createElement<Attributes & AttrType>(Icon[icon], attr);

  return (
    <IconWrapper ref={ref} color={color} size={size} {...(other as HTMLProps)}>
      {DynamicIcon as React.ReactNode}
    </IconWrapper>
  );
});

MaterialIcon.displayName = 'MaterialIcon';

export default MaterialIcon;
